import React from "react";
import loader from '../../../assets/images/loader_white.gif';
import './Spinner.css';

const Spinner = () => (
    <div className="busy_loader">
        <img src={loader} alt="" />
    </div>
);

export default Spinner;